import { type Skills } from '@air/api';

import { type WorkspaceAgentSkillsTab, type WorkspaceAgentSkillType } from '~/constants/workspaceAgentSkillsTypes';

export type UseWorkspaceAgentSkillsListParams = Omit<
  NonNullable<Parameters<typeof Skills.list>[0]>,
  'workspaceId' | 'cursor' | 'scope' | 'scopes' | 'type'
> & {
  workspaceId: string | undefined;
  tab: WorkspaceAgentSkillsTab;
};

export const toWorkspaceAgentSkillsListApiParams = (
  params: UseWorkspaceAgentSkillsListParams,
): Omit<UseWorkspaceAgentSkillsListParams, 'tab'> & {
  scope?: 'private';
  scopes?: ('builtIn' | 'workspace')[];
  type?: WorkspaceAgentSkillType;
} => {
  const { tab, workspaceId, ...rest } = params;

  if (tab === 'private') {
    return { ...rest, workspaceId, scope: 'private' };
  }

  const type: WorkspaceAgentSkillType = tab === 'organization' ? 'organization' : 'canvas';

  return {
    ...rest,
    workspaceId,
    scopes: ['workspace', 'builtIn'],
    type,
  };
};
